import { Link } from '@hypothesis/frontend-shared';
import { jsx as _jsx } from "preact/jsx-runtime";
/**
 * Display information about an annotation's user. Link to the user's
 * activity if `authorLink` is present.
 */
export default function AnnotationUser(_ref) {
  var authorLink = _ref.authorLink,
    displayName = _ref.displayName;
  var user = _jsx("h3", {
    className: "text-color-text font-bold",
    children: displayName
  });
  if (authorLink) {
    return _jsx(Link, {
      href: authorLink,
      target: "_blank",
      underline: "none",
      variant: "custom",
      children: user
    });
  }
  return _jsx("div", {
    children: user
  });
}
//# sourceMappingURL=AnnotationUser.js.map